var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrowDownSmallBlack = function SvgArrowDownSmallBlack(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu-icon/ant-menu-submenu-arrow-down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55057 10.692C9.16241 10.9483 8.63491 10.9056 8.2932 10.5639L5.46477 7.73545C5.07424 7.34493 5.07424 6.71176 5.46477 6.32124C5.85529 5.93072 6.48846 5.93072 6.87898 6.32124L9.0003 8.44256L11.1217 6.32121C11.5122 5.93069 12.1453 5.93069 12.5359 6.32121C12.9264 6.71174 12.9264 7.3449 12.5359 7.73543L9.70744 10.5639C9.70743 10.5639 9.70742 10.5639 9.70741 10.5639C9.6586 10.6127 9.60601 10.6554 9.55057 10.692Z",
    fill: "black",
    fillOpacity: 0.85
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowDownSmallBlack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "arrow-down-small-black.d5533abac299ed6ced38998f088cdbce.svg";